import { render, staticRenderFns } from "./studyReport.vue?vue&type=template&id=0bb210dc&scoped=true&"
import script from "./studyReport.vue?vue&type=script&lang=js&"
export * from "./studyReport.vue?vue&type=script&lang=js&"
import style0 from "./studyReport.vue?vue&type=style&index=0&id=0bb210dc&scoped=true&lang=scss&"
import style1 from "./studyReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb210dc",
  null
  
)

export default component.exports